import "./Dashboard.css";

import { FullRightArrowDark } from "../../../../assets";
import { InteractionObjectType, OrganisationTypeConstants, ProjectGroupPermission } from "../../../../constants";
import { NotesPanel } from "../../../../templates";
import { UpcomingMilestonesTaskPanel } from "../../../../templates/UpcomingMilestonesTaskPanel";
import { WorkflowTaskPanel } from "../../../../templates/WorkflowTaskPanel";
import { Button, Column, CursorDataGrid, Row, UpcomingMilestones } from "../../../../widget";
import { UpcomingTasksPanel } from "./components/UpcomingTasksPanel";
import { LandholdingDashboardConstants } from "./constants/LandholdingDashboardConstants";
import { useDashboard } from "./useDashboard";
import { useDashboardWorkflowsAndTasks } from "./useDashboardWorkflowsAndTasks";

const Dashboard = (): JSX.Element => {
  const {
    currentUserType,
    landholdingDetails,
    isProjectsGridLoading,
    projectsOnChange,

    notesProjectUuid,
    showNotesPanel,
    closeNotesPanel,
    readGroupProjectsPermission,
  } = useDashboard();

  const {
    isUpcomingTasksLoading,
    upcomingTasksOnChange,

    upcomingMilestones,
    isLoadingMilestones,
    hasMilestonesError,
    showUpcomingMilestonesPanel,
    setShowUpcomingMilestonesPanel,
    showUpcomingTasksPanel,
    setShowUpcomingTasksPanel,

    refreshTasks,
    workflow,
    handleRefresh,

    selectedPanelTask,
    showWorkflowTaskPanel,
    handleCloseWorkflowTaskPanel,
    setSelectedPanelTask,
    setShowWorkflowTaskPanel,
  } = useDashboardWorkflowsAndTasks();

  return (
    <>
      <div className="TemplateTabCard">
        <Row spacingV="ml">
          <Column span={12}>
            <Row spacingV="ml">
              <Column span={12}>
                <h2>Projects</h2>
              </Column>
            </Row>

            <CursorDataGrid
              filterable
              sortable
              onChange={projectsOnChange}
              columns={LandholdingDashboardConstants.getProjectsCoumns(
                readGroupProjectsPermission !== ProjectGroupPermission.NONE
              )}
              dataIsLoading={isProjectsGridLoading}
              data={[]}
              clientSide={false}
              showTotalCount={false}
              hasBottomMargin={false}
              variant={currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "seed" : "default"}
            />
          </Column>
        </Row>
      </div>
      {readGroupProjectsPermission !== ProjectGroupPermission.NONE && (
        <div className="TemplateTabCard PaddingSmall">
          <Row>
            <Column span={12} hasNoPadding>
              <UpcomingMilestones
                milestones={upcomingMilestones}
                onViewAll={() => setShowUpcomingMilestonesPanel(true)}
                isLoading={isLoadingMilestones}
                hasError={hasMilestonesError}
                loadingCardCount={5}
              />
            </Column>
          </Row>
        </div>
      )}
      {readGroupProjectsPermission !== ProjectGroupPermission.NONE && (
        <div className="TemplateTabCard">
          <Row spacingV="ml">
            <Column span={12}>
              <Row spacingV="ml" justify="between" align="center">
                <Column span={6}>
                  <p className="body01">Upcoming tasks</p>
                </Column>
                <Button
                  className="ViewMoreButton"
                  text="View more"
                  onClick={() => setShowUpcomingTasksPanel(true)}
                  variant="secondary"
                  icon={<FullRightArrowDark />}
                  minWidth={false}
                />
              </Row>
              <CursorDataGrid
                filterable={false}
                sortable
                onChange={upcomingTasksOnChange}
                columns={LandholdingDashboardConstants.UPCOMING_TASKS_COLUMNS}
                dataIsLoading={isUpcomingTasksLoading}
                data={[]}
                clientSide={false}
                showTotalCount={false}
                hasBottomMargin={false}
                refresh={refreshTasks}
                noDataMessage="No upcoming tasks to display"
                hasScrollButton={false}
                variant={currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "seed" : "default"}
              />
            </Column>
          </Row>
        </div>
      )}
      {notesProjectUuid && (
        <NotesPanel
          objectUuid={notesProjectUuid}
          objectType={InteractionObjectType.PROJECT}
          show={showNotesPanel}
          onClose={() => closeNotesPanel()}
        />
      )}
      {readGroupProjectsPermission !== ProjectGroupPermission.NONE && (
        <UpcomingMilestonesTaskPanel
          groupUuid={landholdingDetails?.groupGuid}
          show={showUpcomingMilestonesPanel}
          isDashboard
          onClose={() => setShowUpcomingMilestonesPanel(false)}
          setSelectedPanelTask={setSelectedPanelTask}
          setShowWorkflowTaskPanel={setShowWorkflowTaskPanel}
          refreshTasks={refreshTasks}
        />
      )}
      {readGroupProjectsPermission !== ProjectGroupPermission.NONE && (
        <UpcomingTasksPanel
          groupUuid={landholdingDetails?.groupGuid}
          show={showUpcomingTasksPanel}
          onClose={() => setShowUpcomingTasksPanel(false)}
          setSelectedPanelTask={setSelectedPanelTask}
          setShowWorkflowTaskPanel={setShowWorkflowTaskPanel}
          refreshTasks={refreshTasks}
        />
      )}
      {readGroupProjectsPermission !== ProjectGroupPermission.NONE && (
        <WorkflowTaskPanel
          task={selectedPanelTask}
          currentStepUuid={selectedPanelTask?.step?.uuid}
          workflow={workflow}
          show={showWorkflowTaskPanel}
          refresh={refreshTasks}
          handleRefresh={handleRefresh}
          onClose={handleCloseWorkflowTaskPanel}
        />
      )}
    </>
  );
};

export default Dashboard;
